import { css } from "@emotion/react";
import styled from "@emotion/styled";

import type { ResponsiveVariants } from "shared/lib/styles";
import {
  alignmentCssVariableValues,
  setAlignmentVariables,
  setFullViewportWidthStyles,
  theme,
  transientOptions,
} from "shared/lib/styles";

type StyledProps = {
  $contentResponsivePadding?: Partial<ResponsiveVariants<number>>;
  $pageResponsivePadding?: Partial<ResponsiveVariants<number>>;
};
export const PageContainer = styled.div<StyledProps>`
  ${props => setAlignmentVariables(props.$contentResponsivePadding, props.$pageResponsivePadding)}
  display: flex;
  flex-flow: column;
  justify-content: stretch;
  align-items: stretch;

  max-inline-size: 1560px;
  min-block-size: 100vh;
  margin: auto;
  padding-inline: ${alignmentCssVariableValues.pageAlignmentPaddingInline};
  box-sizing: content-box;
`;

type FooterContainerProps = {
  $ssrFooter?: boolean;
};
export const FooterContainer = styled("footer", transientOptions)<FooterContainerProps>`
  ${setFullViewportWidthStyles()}

  ${props =>
    props.$ssrFooter &&
    css`
      margin-block-start: 20px;

      ${theme.breakpoints.up("tablet")} {
        margin-block-start: 32px;
      }
    `}
`;

export const AfterPageLayoutContainer = styled.div`
  display: inline;
`;

export const Content = styled.main`
  flex: 1;

  min-block-size: 50vh;
  padding-inline: ${alignmentCssVariableValues.contentAlignmentPaddingInline};
`;

export const EmbedPageContainer = styled.div``;
